import {useEffect, useState} from 'react'
import {matchPath, useLocation, useNavigate} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

import {useLogout} from '../../../../hooks/auth/useLogout'
import {useHasUnreadNotifications} from '../../../../hooks/notification/useHasUnreadNotifications'

import Icon from '../../../ui/Icon'
import {UserMenu} from './userMenu/UserMenu'
import {Button} from '../../../buttons/Button'

import {useApp} from '../../../../contexts/AppContext'
import {useAuth} from '../../../../contexts/AuthContext'
import {useProfileContext} from '../../../../contexts/ProfileContext'
import {BannerKind} from '../../../../types/contexts/AppContext'
import {ROUTE_LABELS} from '../../../../constants/navigation'
import {getFromToken, JwtKeys} from '../../../../utils/jwtUtils'
import {displayName} from '../../../../utils/profile/profile'
import {Offcanvas} from 'bootstrap'

const TopBar = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { t } = useTranslation('nav')
  const { showBanner } = useApp()
  const { authInfo } = useAuth()
  const { profile, pictureUrl } = useProfileContext()
  const { logout } = useLogout()
  const [hasUnread, setHasUnread] = useState(false)

  const { hasUnreadNotifications, error, resetState } =
    useHasUnreadNotifications()

  useEffect(() => {
    if (error) {
      showBanner({
        kind: BannerKind.ERR,
        msg: error,
      })
    }

    resetState()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  useEffect(() => {
    // TODO: Enable when the has-unread endpoint is implemented.
    // getHasUnreadNotifications()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const getHasUnreadNotifications = async () => {
    const resp = await hasUnreadNotifications()
    if (resp) {
      setHasUnread(resp.hasUnread)
    }
  }

  const routeLabel = ROUTE_LABELS.find(route =>
    matchPath({ path: route.path, end: true }, pathname)
  )?.label
  const screenLabel = routeLabel ? t(routeLabel) : ''
  const userEmail = getFromToken(authInfo?.accessToken ?? '', JwtKeys.EMAIL)

  const handleMobileMenu = () => {
    const el = document.getElementById('sidenav')
    if (!el) return
    Offcanvas.getOrCreateInstance(el).show()
  }

  return (
    <header className="ph-top">
      <Button
        className="ph-iconbtn d-lg-none"
        variant="ghost"
        icon={<Icon name="menu" size={20} />}
        iconOnly
        label={t('top-bar.open-menu')}
        onClick={handleMobileMenu}
      />
      <div className="ph-crumbs">
        <span>{t('top-bar.home')}</span>
        <span className="separator">/</span>
        <span className="now">{screenLabel}</span>
      </div>
      <div className="ph-top-spacer" />

      {/* <SearchInput
        className="d-none d-xl-flex"
        iconName="search"
        iconSize={15}
        shortcutKey="k"
        placeholder={t('top-bar.search-placeholder')}
        aria-label={t('top-bar.search-placeholder')}
      /> */}

      {/* <Tippy
        content={t('top-bar.notifications')}
        placement="top"
        className="ph-tooltip"
      >
        <Button
          className="ph-iconbtn"
          variant="ghost"
          icon={
            <>
              <Icon name="bell" size={17} />
              {hasUnread && <span className="dot" />}
            </>
          }
          iconOnly
          label={t('top-bar.notifications')}
          onClick={() => navigate('/notifications')}
        />
      </Tippy> */}

      <UserMenu
        name={displayName(
          profile?.firstName,
          profile?.lastName?.trim()
            ? `${profile.lastName.trim()[0]}.`
            : undefined,
          userEmail ?? ''
        )}
        fullName={displayName(
          profile?.firstName,
          profile?.lastName,
          userEmail ?? ''
        )}
        email={userEmail ?? undefined}
        picture={pictureUrl}
        skillLevel={profile?.skillLevel}
        items={[
          {
            path: '/account/profile',
            label: t('user-menu.profile'),
            icon: 'user',
          },
          {
            path: '/account/payments',
            label: t('user-menu.billing'),
            icon: 'card',
          },
          {
            path: '/account/preferences',
            label: t('user-menu.preferences'),
            icon: 'settings',
          },
          {
            path: '/help',
            label: t('user-menu.help'),
            icon: 'info',
          },
        ]}
        onNavigate={navigate}
        onSignOut={logout}
      />
    </header>
  )
}

export default TopBar
